import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { updateService } from "../../services/ondcService";
import Loader2 from "../common/Loader2";
import PaymentScreen from "./PaymentScreen";

function ExpansionPanel({
  title,
  children,
  defaultOpen = false,
}: {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border border-gray-300 rounded-lg">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex justify-between items-center px-4 py-3 text-left font-medium text-gray-700 hover:bg-gray-100"
      >
        {title}
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </button>

      {isOpen && <div className="px-4 pb-4">{children}</div>}
    </div>
  );
}

interface ViewDocumentProps {
  order: any; // replace with your Order type
  open: boolean;
  onClose: () => void;
}

export default function ViewLoanDetails({ order, open, onClose }: ViewDocumentProps) {
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [amount, setAmount] = useState("");
  const [formIsComplete, setFormIsComplete] = useState(false);
  const [loading, setLoading] = useState(false); // start false (page load)
  

  if (!open || !order) return null;
  if (!open || !order) return null;


  const prePayment = () => {
    setIsOpen2(true)
  }

  const checkForm = () => {
    if(amount != ""){
      setFormIsComplete(true)
    }else{
      setFormIsComplete(false)
    }
  }

  const getPaymentLink = async (codeLabel: string) => {
    localStorage.setItem("transaction_id", order.transaction_id);
    localStorage.setItem("update_id", uuidv4());
    var paymentData;
    if(codeLabel == 'PRE_PART_PAYMENT'){
      paymentData = {
        "transaction_id": order.transaction_id,
        "message_id": localStorage.getItem("update_id"),
        "bpp_id": order.bpp_id,
        "bpp_uri": order.bpp_uri,
        "action":"update",
        "order_id": order.loan_id,
        "version": order.version,
        "update_target": "payments",
        "code_label": codeLabel,
        "amount": amount
      }
    } else {
      paymentData = {
        "transaction_id": order.transaction_id,
        "message_id": localStorage.getItem("update_id"),
        "bpp_id": order.bpp_id,
        "bpp_uri": order.bpp_uri,
        "action":"update",
        "order_id": order.loan_id,
        "version": order.version,
        "update_target": "payments",
        "code_label": codeLabel
      }
    } 
    console.log(paymentData)
    setIsOpen2(false)
    setAmount("")
    setFormIsComplete(false)
    try {
      setLoading(true); // show loader
      const response = await updateService(paymentData);
      console.log(response)
      if (response.success) {
        await new Promise((resolve) => setTimeout(resolve, 5000));
        setIsOpen3(true)
      }else{
        setIsOpen3(false)
      }
    } catch (err) {
      console.error("Error fetching offers:", err);
    } finally {
      setLoading(false); // hide loader
    }
  }

  return (
    <>
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-xl 
        w-full max-h-screen overflow-y-auto p-6 relative
        max-w-sm sm:max-w-md md:max-w-2xl lg:max-w-4xl xl:max-w-6xl"
      >
        {/* Close button */}
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          onClick={onClose}
        >
          ✕
        </button>
        {!loading && (
          <div className="basis-3/5 h-[500px] flex flex-col p-8 bg-white">
            {/* Scrollable content */}
            <div className="flex-1 overflow-y-auto">
              <h2 className="text-xl font-semibold mb-6">LOAN Details</h2>

              {/* Extra Fields */}
              <div className="space-y-6">
                {/* Text Field */}
                <div>
                  <label className="block text-sm text-gray-600 mb-1">
                    Loan ID
                  </label>
                  <div className="flex items-center border border-gray-300 rounded-lg">
                    <input
                      type="text"
                      value={order.loan_id}
                      readOnly
                      disabled
                      className="w-full px-4 py-2 rounded-r-lg focus:ring-2 focus:ring-blue-500 outline-none border-0"
                    />
                  </div>
                </div>

                {/* Duration Field */}
                <div>
                  <label className="block text-sm text-gray-600 mb-1">
                    Loan Status
                  </label>
                  <input
                    type="text"
                    value={order.amount_status}
                    readOnly
                    disabled
                    className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                  />
                </div>

                {/* Duration Field */}
                <div>
                  <label className="block text-sm text-gray-600 mb-1">
                    Loan Amount
                  </label>
                  <div className="flex items-center border border-gray-300 rounded-lg">
                    <span className="px-3 text-gray-600">Rs.</span>
                    <input
                      type="text"
                      value={order.loan_amount}
                      readOnly
                      disabled
                      className="w-full px-4 py-2 rounded-r-lg focus:ring-2 focus:ring-blue-500 outline-none border-0"
                    />
                  </div>
                </div>

                {/* Duration Field */}
                <div>
                  <label className="block text-sm text-gray-600 mb-1">
                    EMI
                  </label>
                  <div className="flex items-center border border-gray-300 rounded-lg">
                    <span className="px-3 text-gray-600">Rs.</span>
                    <input
                      type="text"
                      value={order.emi}
                      readOnly
                      disabled
                      className="w-full px-4 py-2 rounded-r-lg focus:ring-2 focus:ring-blue-500 outline-none border-0"
                    />
                  </div>
                </div>

                {/* Duration Field */}
                <div>
                  <label className="block text-sm text-gray-600 mb-1">
                    Loan Tenure
                  </label>
                  <div className="flex items-center border border-gray-300 rounded-lg">
                    <input
                      type="text"
                      value={order.loan_tenure}
                      readOnly
                      disabled
                      className="w-full px-4 py-2 rounded-r-lg focus:ring-2 focus:ring-blue-500 outline-none border-0"
                    />
                  </div>
                </div>

                {/* Duration Field */}
                <div>
                  <label className="block text-sm text-gray-600 mb-1">
                    Lender's Name
                  </label>
                  <div className="flex items-center border border-gray-300 rounded-lg">
                    <input
                      type="text"
                      value={order.lender_name}
                      readOnly
                      disabled
                      className="w-full px-4 py-2 rounded-r-lg focus:ring-2 focus:ring-blue-500 outline-none border-0"
                    />
                  </div>
                </div>

                {/* Duration Field */}
                <div>
                  <label className="block text-sm text-gray-600 mb-1">
                    GRO Name
                  </label>
                  <div className="flex items-center border border-gray-300 rounded-lg">
                    <input
                      type="text"
                      value={order.gro_name}
                      readOnly
                      disabled
                      className="w-full px-4 py-2 rounded-r-lg focus:ring-2 focus:ring-blue-500 outline-none border-0"
                    />
                  </div>
                </div>

                {/* Duration Field */}
                <div>
                  <label className="block text-sm text-gray-600 mb-1">
                    GRO Email
                  </label>
                  <div className="flex items-center border border-gray-300 rounded-lg">
                    <input
                      type="text"
                      value={order.gro_email}
                      readOnly
                      disabled
                      className="w-full px-4 py-2 rounded-r-lg focus:ring-2 focus:ring-blue-500 outline-none border-0"
                    />
                  </div>
                </div>

                {/* Duration Field */}
                <div>
                  <label className="block text-sm text-gray-600 mb-1">
                    GRO Contact
                  </label>
                  <div className="flex items-center border border-gray-300 rounded-lg">
                    <input
                      type="text"
                      value={order.gro_contact}
                      readOnly
                      disabled
                      className="w-full px-4 py-2 rounded-r-lg focus:ring-2 focus:ring-blue-500 outline-none border-0"
                    />
                  </div>
                </div>

                {/* Accordion Panels */}
                <ExpansionPanel title="Loan Breakup">
                  {order?.breakup?.map((breakup: any, index: number) => (
                  <div key={index} className="mb-4">
                    <label className="block text-sm text-gray-600 mb-1">
                      {breakup.title}
                    </label>
                    <input
                      readOnly
                      disabled
                      type="text"
                      value={breakup.price.value || ""}
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                    />
                  </div>
                ))}
                </ExpansionPanel>

                {/* Accordion Panels */}
                <ExpansionPanel title="Loan Info">
                  {order?.loan_info.map((tag: any, index: number) => (
                  <div key={index} className="mb-4">
                    <label className="block text-sm text-gray-600 mb-1">
                      {tag.descriptor.name}
                    </label>
                    <input
                      readOnly
                      disabled
                      type="text"
                      value={tag.value || ""}
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                    />
                  </div>
                ))}
                </ExpansionPanel>

                {/* Accordion Panels */}
                <ExpansionPanel title="EMI Schedule">
                  <div className="flex items-center justify-between text-sm text-gray-700">
                    <div className="flex-1 text-center">
                      <p className="font-bold">Due Date</p>
                    </div>

                    <div className="border-l border-gray-400 h-5"></div>

                    <div className="flex-1 text-center">
                      <p className="font-bold">EMI Amount</p>
                    </div>

                    <div className="border-l border-gray-400 h-5"></div>

                    <div className="flex-1 text-center">
                      <p className="font-bold">Status</p>
                    </div>
                  </div>
                  {order?.payment_schedule.map((tag: any, index: number) => (
                  <div className="flex items-center justify-between text-sm text-gray-700">
                    <div className="flex-1 text-center">
                      {tag.status == 'PAID' && (
                          <p className="text-gray-600">--NA--</p>
                      )}
                      {tag.status != 'PAID' && tag.url == null && (
                          <p className="text-gray-600">{new Date(tag.time.range.end).toISOString().split("T")[0]}</p>
                      )}
                    </div>

                    <div className="border-l border-gray-400 h-5"></div>

                    <div className="flex-1 text-center">
                      <p className="text-gray-600">Rs. {tag.params.amount}</p>
                    </div>

                    <div className="border-l border-gray-400 h-5"></div>

                    <div className="flex-1 text-center">
                      <p className="text-gray-600">{tag.status}</p>
                    </div>
                  </div>
                ))}
                </ExpansionPanel>

                {/* Action Buttons */}
                {order.amount_status == "DISBURSED" && (
                <div className="mt-6 flex flex-wrap justify-end gap-3 border-t pt-4">
                  <button
                    onClick={prePayment}
                    className="rounded-md border border-indigo-600 px-4 py-2 text-sm font-medium text-indigo-600 hover:bg-indigo-50 focus:outline-none"
                  >
                    Pre-payment
                  </button>
                  <button
                    onClick={() => getPaymentLink("FORECLOSURE")}
                    className="rounded-md border border-red-600 px-4 py-2 text-sm font-medium text-red-600 hover:bg-red-50 focus:outline-none"
                  >
                    Foreclosure
                  </button>
                  <button
                    onClick={() => getPaymentLink("MISSED_EMI_PAYMENT")}
                    className="rounded-md border border-yellow-600 px-4 py-2 text-sm font-medium text-yellow-600 hover:bg-yellow-50 focus:outline-none"
                  >
                    Missed EMI
                  </button>
                </div>
                )}
              </div>
            </div>
          </div>
        )}

        {loading && (
          <div className="flex items-center justify-center min-h-screen bg-[#f5f9ff]">
            <Loader2 />
          </div>
        )}
      </div>
    </div>
    {/* Overlay */}
    {isOpen2 && (
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        {/* Dialog box */}
        <div className="bg-white rounded-2xl shadow-lg p-6 w-80">
          <h2 className="text-lg font-semibold mb-4">Enter Amount for Pre-Payment</h2>
          <div>
            <label className="block text-sm text-gray-600 mb-1">
              {/* Desired Loan Amount (min Rs. 30000) */}
            </label>
            <div className="flex items-center border border-gray-300 rounded-lg">
              <span className="px-3 text-gray-600">Rs.</span>
              <input
                type="number"
                value={amount}
                onKeyUp={(e) => checkForm()}
                onChange={(e) => {
                  setAmount(e.target.value)
                }}
                placeholder="Enter Amount"
                className="w-full px-4 py-2 rounded-r-lg focus:ring-2 focus:ring-blue-500 outline-none border-0"
              />
            </div>
          </div>
          {/* Next Buttons in a row */}
          <div className="mt-6 flex gap-4">
            <button
              className="flex-1 bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition flex items-center justify-center gap-2"
              onClick={() => setIsOpen2(false)}
            >
            Cancel
            </button>

            <button
              className={`flex-1 px-8 py-3 rounded-lg font-semibold flex items-center justify-center gap-2 transition
                ${formIsComplete
                  ? "bg-blue-600 text-white hover:bg-blue-700"
                  : "bg-gray-400 cursor-not-allowed"}`}
              onClick={() => {
                getPaymentLink("PRE_PART_PAYMENT");
              }}
              disabled={!formIsComplete}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    )}
    {isOpen3 && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-xl 
        w-full max-h-screen overflow-y-auto p-6 relative
        max-w-sm sm:max-w-md md:max-w-2xl lg:max-w-4xl xl:max-w-6xl"
      >
        {/* Close button */}
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          onClick={() => {
            onClose();
            setIsOpen2(false);
            setIsOpen3(false);
          }}
        >
          ✕
        </button>
        <div className="basis-3/5 h-[500px] flex flex-col p-8 bg-white">
          {/* Scrollable content */}
          <div className="flex-1 overflow-y-auto">
            <div className="space-y-6">
              <PaymentScreen />
            </div>
          </div>
        </div>
      </div>
    </div>
    )}
    </>
  );
}

